import { submitMove } from '@otto-ec/tracking-bct';
import { getProductFeaturesForNonPdpPage } from '../../../_common/client/tracking/get-product-features-for-non-pdp-page';
import { trackMove } from '@otto-ec/nexus-registry/pdp/tracking';

export function registerMoveTracking(variationId: string) {
    trackMove.assignFunction((dataContainer, action) => {
        submitMove(dataContainer, {
            name: action?.name || 'click',
            features: (action?.features || []).concat(getProductFeaturesForNonPdpPage(variationId)),
        });
    });
}
